// Single place for the legal/business details used across the
// terms/privacy/refunds/contact pages. Entity/jurisdiction sourced from
// anyainow.ai's own live privacy page footer ("anyAInow is the trading name
// of l3techconsult BV (BE 0774.932.208)") — same operator/infrastructure as
// this app, so the same entity applies here.
export const SUPPORT_EMAIL = "ai@freeainow.io";
export const PRIVACY_EMAIL = "ai@freeainow.io";
export const LEGAL_ENTITY = "l3techconsult BV (BE 0774.932.208)";
export const LEGAL_JURISDICTION = "Belgium";
export const LEGAL_COURTS = "Brussels, Belgium";
